import React, { ComponentType } from 'react';

import { useSelector } from 'react-redux';

import { WebItems } from '@atlassian/bitbucket-connect-react';

import { branchTarget } from 'src/connect/targets';
import {
  getCurrentRepositoryOwnerName,
  getCurrentRepositorySlug,
} from 'src/selectors/repository-selectors';
import { getTargetUserKey } from 'src/selectors/user-selectors';

export type BranchSummaryActionsProps = {
  component: ComponentType<React.PropsWithChildren<any>>;
  name: string;
};

export const ConnectBranchSummaryActions = (
  props: BranchSummaryActionsProps
) => {
  const principalId = useSelector(getTargetUserKey) || '';
  const repositoryOwner = useSelector(getCurrentRepositoryOwnerName) || '';
  const repositorySlug = useSelector(getCurrentRepositorySlug) || '';

  const { name, component } = props;

  return (
    <WebItems
      location="org.bitbucket.branch.summary.actions"
      principalId={principalId}
      target={branchTarget({
        name,
        repositoryOwner,
        repositorySlug,
      })}
      component={component}
      loadingComponent={() => null}
      loadingFailedComponent={() => null}
    />
  );
};
